import { parseCSV } from './parseCsv';
import { getFoodImageUrl } from './images';

export interface ComboItem {
  name: string;
  url: string;
  quantity: number;
}

const stripQuotes = (value: string = ''): string => value.replace(/^['"]|['"]$/g, '');

// Fetched once and shared by every combo card.
let combosPromise: Promise<Map<string, ComboItem[]>> | null = null;

const loadCombos = (): Promise<Map<string, ComboItem[]>> => {
  if (!combosPromise) {
    combosPromise = fetch('/dinners_expanded.csv')
      .then(res => {
        if (!res.ok) throw new Error('Failed to fetch');
        return res.text();
      })
      .then(text => {
        const combos = new Map<string, ComboItem[]>();
        parseCSV(text).forEach(row => {
          const combo = stripQuotes(row.combo);
          const name = stripQuotes(row.item);
          if (!combo || !name) return;
          const quantity = parseInt(stripQuotes(row.quantity), 10) || 1;
          const items = combos.get(combo) || [];
          items.push({ name, url: getFoodImageUrl(name, stripQuotes(row.category)), quantity });
          combos.set(combo, items);
        });
        return combos;
      })
      .catch(err => {
        combosPromise = null;
        throw err;
      });
  }
  return combosPromise;
};

export const getComboItems = async (comboName: string): Promise<ComboItem[]> =>
  (await loadCombos()).get(comboName) || [];
